import { lazy, Suspense, useMemo } from "react";
import MarketMindPanel from "./MarketMindPanel";
import { tiktokMarketGames } from "../services/tiktokMarket";
import "./marketMind.css";

const TikTokOpportunityMap = lazy(() => import("./TikTokOpportunityMap"));
const NO_MARKET_FAVORITES = [];
const formatNumber = value => value == null ? "—" : Number(value).toLocaleString();

function TikTokMarketDetails({ node, onClose, pinned }) {
  const game = node.data;
  return <div className="ms-tooltip mg-tiktok-market-details" onClick={event => event.stopPropagation()}>
    <div className="mg-tiktok-market-tooltip-heading">
      {game.image && <img src={game.image} alt="" />}
      <div><strong>{game.displayName || game.name}</strong><span>{game.publisher || "TikTok tracked title"}</span></div>
      {pinned && <button type="button" onClick={onClose} aria-label="Close game details">×</button>}
    </div>
    <dl>
      <div><dt>{game.marketMetric === "videos" ? "Videos" : "Views"} {game.metricLabel || "total"}</dt><dd>{formatNumber(game.value)}</dd></div>
      <div><dt>Latest Views</dt><dd>{formatNumber(game.views)}</dd></div>
      <div><dt>Latest Videos</dt><dd>{formatNumber(game.videos)}</dd></div>
      <div><dt>Observed Growth</dt><dd>{formatNumber(game.delta)}{game.delta != null && ` (${(game.growth * 100).toFixed(1)}%)`}</dd></div>
      {game.coverageLabel && <div><dt>Coverage</dt><dd>{game.coverageLabel}</dd></div>}
      {game.release_date && <div><dt>Release</dt><dd>{game.release_date}</dd></div>}
      {game.genres?.length > 0 && <div><dt>Genres</dt><dd>{game.genres.join(", ")}</dd></div>}
    </dl>
  </div>;
}

const renderDetails = props => <TikTokMarketDetails {...props} />;
export default function TikTokMarketMind({ games, filtered, comparisonGames = [], setComparisonGames, setShowInsights,
  onToggleComparisonGame,
  splitView, onSplitChange, hasActiveFilters, growthWindow, rankingWindow = "latest",
  metric = "views", shape, onShapeChange, sort, loading }) {
  const rows = useMemo(() => tiktokMarketGames(games, growthWindow, sort, metric), [games, growthWindow, sort, metric]);
  const opportunityRows = useMemo(() => games
    .filter(game => game.momentumEligible && game.momentumMetrics?.viewsAdded7d > 0)
    .map(game => ({
      ...game,
      name: game.displayName || game.name,
      id: game.selectionKey || game.gameKey || game.name,
      mindshare: game.momentumMetrics.viewsAdded7d,
    })), [games]);
  const label = `${rankingWindow === "latest" ? "Total" : rankingWindow.toUpperCase() + " gained"} ${metric === "videos" ? "Videos" : "Views"}`;
  const marketProps = { metricLabel: `TikTok ${label}`, renderDetails, colorMode: "total",
    asyncLayout: true, loaderLabel: "TikTok Market Mind" };
  return <MarketMindPanel label="TikTok Market Mind" rows={rows} filtered={filtered}
    selectionIds={comparisonGames} splitView={splitView} onSplitChange={onSplitChange} hasActiveFilters={hasActiveFilters}
    shape={shape} onShapeChange={onShapeChange} favorites={NO_MARKET_FAVORITES}
    loading={loading} marketProps={marketProps} opportunityMapRows={opportunityRows} showToolbar={false}
    centeredCanvas
    opportunityMapRenderer={({ width, height, rows: visibleRows, selectionIds, favorites: selectedFavorites }) => (
      <Suspense fallback={<div className="tt-opportunity-map-loading" role="status">Loading Opportunity Map…</div>}>
        <TikTokOpportunityMap rows={opportunityRows} visibleRows={visibleRows} width={width} height={height}
          selectionIds={selectionIds} favorites={selectedFavorites}
          onSelect={game => {
            if (onToggleComparisonGame) {
              onToggleComparisonGame(game);
              return;
            }
            const selectionKey = game.selectionKey || game.name;
            if (!selectionKey || !setComparisonGames) return;
            setShowInsights?.(true);
            setComparisonGames(previous => previous.includes(selectionKey)
              ? previous.filter(value => value !== selectionKey)
              : [...previous, selectionKey]);
          }} />
      </Suspense>
    )} />;
}
